// 自定义指令 【弃用】
import { ElMessage } from 'element-plus'

/**
 * 特殊字符过滤指令
 * 使用方式：
 * 1. 基本用法：v-no-special-chars
 * 2. 自定义提示：v-no-special-chars="{ message: '自定义提示' }"
 * 3. 禁用提示：v-no-special-chars="{ showMessage: false }"
 */

export const noSpecialCharsDirective = {
  mounted(el, binding) {
    const input = el.querySelector('input') || el
    const { value: options = {} } = binding

    let isComposing = false // 标记是否在中文输入中
    let debounceTimer = null
    let lastMessageTime = 0
    const MESSAGE_COOLDOWN = 1000

    // 处理输入法组合事件
    const handleCompositionStart = () => {
      isComposing = true
    }

    const handleCompositionEnd = (e) => {
      isComposing = false
      // 组合输入结束后，手动触发一次过滤
      handleInput(e)
    }

    const handleInput = (e) => {
      // 如果在中文输入过程中，跳过处理
      if (isComposing) {
        return
      }

      clearTimeout(debounceTimer)
      debounceTimer = setTimeout(() => {
        const oldValue = e.target.value

        // 修改正则：允许空格
        // [^\u4e00-\u9fa5a-zA-Z0-9\s] 中的 \s 代表空白字符（包括空格）
        const newValue = oldValue.replace(/[^\u4e00-\u9fa5a-zA-Z0-9\s]/g, '')

        if (newValue !== oldValue) {
          e.target.value = newValue
          e.target.dispatchEvent(new Event('input'))

          const now = Date.now()
          if (now - lastMessageTime > MESSAGE_COOLDOWN) {
            if (options.showMessage !== false) {
              ElMessage.warning(options.message || '输入内容不允许包含特殊符号')
            }
            lastMessageTime = now
          }
        }
      }, 10)
    }

    // 存储处理函数引用
    el._inputHandler = handleInput
    el._compositionStartHandler = handleCompositionStart
    el._compositionEndHandler = handleCompositionEnd

    // 添加事件监听
    input.addEventListener('input', handleInput)
    input.addEventListener('compositionstart', handleCompositionStart)
    input.addEventListener('compositionend', handleCompositionEnd)
  },

  unmounted(el) {
    const input = el.querySelector('input') || el
    if (el._inputHandler) {
      input.removeEventListener('input', el._inputHandler)
    }
    if (el._compositionStartHandler) {
      input.removeEventListener('compositionstart', el._compositionStartHandler)
    }
    if (el._compositionEndHandler) {
      input.removeEventListener('compositionend', el._compositionEndHandler)
    }
  }
}
